import { PermissionEnum } from "src/app/models/auth0/permission.enum";
import { IEnvironment } from "./ienvironment";

export const environment: IEnvironment = {
    name: "prod",
    production: true,
    api_base_url: "https://api.zenity.io",
    api_version: "v1",
    api_beta_version: "v1-beta",
    app_base_url: "https://app.zenity.io",
    auth0: {
        domain: "zenity-prod.eu.auth0.com",
        clientId: "f49pqgC3osHquohKsjtdOSNRIQ85z4QD",
        audience: "https://zenity-prod.eu.zenity.io/api/v3",
        scope: ["openid", "profile", "email", PermissionEnum.admin, PermissionEnum.operator, PermissionEnum.analyst, PermissionEnum.viewer],
    },
    dd: {
        enabled: true,
        clientToken: "pub9b4c6c19493d5eb3a30a936b3cfb150e",
        env: "prod",
        service: "web-prod",
        forwardErrorsToLogs: true,
    },
    msal: {
        oauthClientId: "1b536350-f54d-478d-a822-d71ba66e2444",
    },
    zenityRedirectUriForOauthAuthorizationCodeFlow: "https://app.zenity.io/app/oauth-authorization-code-redirect",
};
